module.exports = __webpack_public_path__ + "assets/logo.f712064d.svg";